import Lenis from 'lenis';

// Module-level singleton so Navigation / BackToTop / route manager can
// drive scrolling imperatively without prop-drilling a context.
let lenis = null;
let rafId = null;

const NAV_OFFSET = -76;

export function initLenis() {
  if (lenis) return lenis;
  lenis = new Lenis({
    lerp: 0.1,
    wheelMultiplier: 1,
    syncTouch: false, // touch scrolling stays native on mobile
  });
  const raf = (time) => {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  };
  rafId = requestAnimationFrame(raf);
  return lenis;
}

export function destroyLenis() {
  if (rafId) cancelAnimationFrame(rafId);
  rafId = null;
  lenis?.destroy();
  lenis = null;
}

export function getLenis() {
  return lenis;
}

export function scrollToTarget(target, opts = {}) {
  if (lenis) {
    lenis.scrollTo(target, { offset: NAV_OFFSET, duration: 1.1, ...opts });
    return;
  }
  // Native fallback (reduced motion / Lenis not mounted)
  if (typeof target === 'number') {
    window.scrollTo({ top: target, behavior: opts.immediate ? 'auto' : 'smooth' });
    return;
  }
  const el = typeof target === 'string' ? document.querySelector(target) : target;
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY + (opts.offset ?? NAV_OFFSET);
    window.scrollTo({ top, behavior: opts.immediate ? 'auto' : 'smooth' });
  }
}
